import { render, staticRenderFns } from "./SubmerchantEdit.vue?vue&type=template&id=265efc02&"
import script from "./SubmerchantEdit.vue?vue&type=script&lang=js&"
export * from "./SubmerchantEdit.vue?vue&type=script&lang=js&"
import style0 from "./SubmerchantEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports